// src/pages/AuthCallback.jsx
// This page handles the redirect after Google OAuth
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const processCallback = async () => {
      try {
        const result = await handleGoogleCallback();

        window.dispatchEvent(new Event('authChange'));
        // Google signup: direct to home (no manual login needed)
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Google callback error:', err);
        setError(err.message || 'Google login failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    processCallback();
  }, []);

  if (error) {
    return (
      <div style={styles.page}>
        <div style={styles.box}>
          <h2 style={{ color: '#c62828' }}>❌ Login Failed</h2>
          <p style={{ color: '#666' }}>{error}</p>
          <p style={{ color: '#aaa', fontSize: '13px' }}>Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.box}>
        <div style={styles.spinner}></div>
        <h2 style={{ color: '#764ba2', marginTop: '20px' }}>Signing you in...</h2>
        <p style={{ color: '#888', fontSize: '14px' }}>Please wait a moment</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  box: {
    background: 'white',
    borderRadius: '16px',
    padding: '48px 40px',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    minWidth: '300px',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid #f0eeff',
    borderTop: '4px solid #764ba2',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    margin: '0 auto',
  },
};

// Add spinner animation via a style tag
const styleTag = document.createElement('style');
styleTag.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
document.head.appendChild(styleTag);